<div
  (drop)="onFileChange($event)"
  (dragover)="fileDragOver($event)"
  (dragleave)="fileDragLeave($event)"
  class="tw-relative tw-border tw-border-1 tw-p-3 tw-pe-9 tw-rounded-xl tw-gap-3 tw-flex tw-flex-wrap tw-w-full tw-h-full"
  [ngClass]="[
  isFileDraggedOver ? 'tw-bg-blue-50 tw-border-blue-300 tw-hover:tw-bg-blue-50 tw-hover:tw-border-blue-300' :
  warningMessage ? 'tw-bg-orange-100 tw-hover:tw-bg-orange-100 tw-border-orange-400 tw-hover:tw-border-orange-400' :
  fileList.errors?.['required'] && fileList.touched ? 'tw-bg-red-100 tw-border-red-500 tw-hover:tw-bg-red-200 tw-hover:tw-border-red-600'
  : 'tw-bg-white'
]"
>
  <svg
    [tippyProps]="{ allowHTML: true }"
    ngxTippy="{{ tooltip || (accept | uploadTooltipMessage : minFileSize : maxFileSize) }}"
    class="tw-absolute tw-top-2 tw-end-2 tw-h-5 tw-w-5"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34873 18.9426 4.80688 17.0679 2.93215C15.1931 1.05741 12.6513 0.0029116 10 0ZM10 16C9.80222 16 9.60888 15.9413 9.44443 15.8315C9.27998 15.7216 9.15181 15.5654 9.07612 15.3827C9.00044 15.2 8.98063 14.9989 9.01922 14.8049C9.0578 14.6109 9.15304 14.4327 9.2929 14.2929C9.43275 14.153 9.61093 14.0578 9.80491 14.0192C9.99889 13.9806 10.2 14.0004 10.3827 14.0761C10.5654 14.1518 10.7216 14.28 10.8315 14.4444C10.9414 14.6089 11 14.8022 11 15C11 15.2652 10.8946 15.5196 10.7071 15.7071C10.5196 15.8946 10.2652 16 10 16ZM11 11.466V12C11 12.2652 10.8946 12.5196 10.7071 12.7071C10.5196 12.8946 10.2652 13 10 13C9.73479 13 9.48043 12.8946 9.2929 12.7071C9.10536 12.5196 9 12.2652 9 12V10.582C8.99999 10.4473 9.02718 10.3141 9.07994 10.1902C9.13269 10.0663 9.20992 9.95432 9.307 9.861C9.40334 9.76711 9.51793 9.69399 9.64367 9.64617C9.7694 9.59835 9.90362 9.57685 10.038 9.583C10.2313 9.59 10.4241 9.55788 10.6047 9.48854C10.7853 9.4192 10.95 9.31409 11.089 9.17951C11.228 9.04492 11.3383 8.88365 11.4134 8.70536C11.4885 8.52707 11.5268 8.33545 11.526 8.142C11.5414 7.74417 11.3981 7.35653 11.1277 7.06435C10.8572 6.77217 10.4818 6.59938 10.084 6.584C9.68618 6.56861 9.29854 6.7119 9.00636 6.98233C8.71417 7.25275 8.54139 7.62817 8.526 8.026C8.52284 8.15777 8.49329 8.28757 8.43909 8.40772C8.3849 8.52787 8.30717 8.63594 8.21049 8.72554C8.11381 8.81513 8.00015 8.88443 7.87623 8.92934C7.7523 8.97425 7.62063 8.99385 7.489 8.987C7.22425 8.97659 6.97446 8.86154 6.79446 8.66711C6.61447 8.47268 6.519 8.21476 6.529 7.95C6.55739 7.30694 6.76257 6.68417 7.12196 6.15017C7.48136 5.61616 7.98106 5.19161 8.5661 4.9232C9.15115 4.65478 9.79888 4.5529 10.4381 4.62876C11.0773 4.70462 11.6832 4.95528 12.1891 5.35318C12.6951 5.75107 13.0816 6.28079 13.306 6.88408C13.5304 7.48737 13.5841 8.14087 13.4612 8.7727C13.3383 9.40454 13.0435 9.99024 12.6093 10.4654C12.1751 10.9406 11.6182 11.2868 11 11.466Z"
      fill="#4B5563"
    />
  </svg>
  @for (fileObject of filesObjects; track $index) {
  <div [style.width]="width" [style.height]="height">
    @if(uploadProgressList[$index]){
    <div class="tw-border tw-border-2 tw-rounded-xl tw-border-blue-500 tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full">
      <progress-circle [isInfinite]="false" [uploadProgress]="uploadProgressList[$index || -1]"></progress-circle>
    </div>
    }@else {
    <app-uploaded-file
      [useImageCropper]="useImageCropper"
      [fileObject]="fileObject"
      [canEditFileName]="canEditFileName"
      [displayFilename]="displayFilename"
      (click)="toggleGallery.emit($index)"
      (deleteFile)="deleteFile.emit($index)"
      (cropImage)="cropImage.emit($index)"
      (nameChanged)="nameChanged.emit()"
    ></app-uploaded-file>
    }
  </div>
  } @if(fileList.value.length < maxFilesToUpload){
  <app-upload-input
    class="tw-block"
    [style.width]="width"
    [style.height]="height"
    [accept]="accept"
    [isMultipleInput]="isMultipleInput"
    [fileList]="fileList"
    [maxFilesToUpload]="maxFilesToUpload"
    appearance="multiple-upload"
    (fileChanged)="fileChanged.emit($event)"
  ></app-upload-input>
  }
</div>
<div
  class="message-container tw-text-xs tw-px-3 tw-pt-1"
  [ngClass]="[warningMessage ? 'tw-text-orange-700' : fileList.errors?.['required'] ? 'tw-text-red-500' : 'tw-text-gray-500']"
>
  {{
    warningMessage ||
    (fileList.errors?.['required'] && fileList.touched ? 'This field is required' : '') ||
    hint
  }}
</div>
